import { Component, OnDestroy, computed, inject, input, output } from '@angular/core';
import { InstalledAppleApplication } from '@era/locations-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppleApplicationLockChanged, AppleDeviceDesiredNameChanged, Device } from '@rocksoft/shared';
import { Subscription } from 'rxjs';
import { EditDeviceNameModalComponent } from '../modals/edit-device-name-modal/edit-device-name-modal.component';

@Component({
  selector: 'era-apple-device-ui',
  templateUrl: './apple-device.component.html',
  styleUrls: ['./apple-device.component.scss'],
  imports: [FaIconComponent],
})
export class AppleDeviceComponent implements OnDestroy {
  private readonly modalService = inject(NgbModal);

  public readonly device = input<Device | undefined>(undefined);
  public readonly isAtLatestAllowedOsVersion = input(true);

  readonly displayDesiredName = computed(() => {
    const device = this.device();
    if (!device) return false;

    return (
      device.name != undefined && device.desiredName != undefined && !device.name.endsWith(` ${device.desiredName}`)
    );
  });

  public readonly applicationLockChange = output<AppleApplicationLockChanged>();

  public readonly desiredNameChange = output<AppleDeviceDesiredNameChanged>();

  public readonly updateDeviceEvent = output<string>();

  private modalSubscriptions?: Subscription;

  public callUpdate(udid: string) {
    this.updateDeviceEvent.emit(udid);
  }

  public callLock(udid: string, application: InstalledAppleApplication) {
    this.applicationLockChange.emit(new AppleApplicationLockChanged(udid, application.identifier, true));
  }

  public callUnlock(udid: string, application: InstalledAppleApplication) {
    this.applicationLockChange.emit(new AppleApplicationLockChanged(udid, application.identifier, false));
  }

  public editName() {
    const device = this.device();
    if (!device) {
      return;
    }
    const modalRef = this.modalService.open(EditDeviceNameModalComponent);
    const instance = modalRef.componentInstance as EditDeviceNameModalComponent;
    instance.initialName = device.desiredName;

    this.modalSubscriptions = modalRef.closed.subscribe((x) => {
      this.desiredNameChange.emit(new AppleDeviceDesiredNameChanged(device.udid, x.newName));
      this.unsubscribe();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe() {
    if (this.modalSubscriptions !== undefined) {
      this.modalSubscriptions.unsubscribe();
    }
  }
}
